import React from 'react'
import { Modal, SuspenseBoundary } from 'elements'
import FirstClientModal from './FirstClientModal'

export default function FirstClientModalContainer({ modal, integrationResult, companyId }) {
  return (
    <Modal modal={modal}>
      <SuspenseBoundary>
        <FirstClientModal
          modal={modal}
          integrationResult={integrationResult}
          companyId={companyId}
        />
      </SuspenseBoundary>
    </Modal>
  )
}
